import { WebPageJsonLd } from "next-seo";
import { addBaseUrl } from "./addBaseUrl";

// // // //

interface AssetClassPageSEOProps {
    route: string;
    description: string;
}

/**
 * Renders WebPage JSON-LD structured data for asset class list pages.
 * Used on /treasuries, /stablecoins, /credit, /stocks, /commodities,
 * /government-bonds, /real-estate, /private-equity-venture-capital,
 * and /active-strategies.
 */
export function AssetClassPageSEO(props: AssetClassPageSEOProps) {
    const { route, description } = props;

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const isoYesterday = yesterday.toISOString();

    return (
        <WebPageJsonLd
            id={addBaseUrl(route)}
            description={description}
            lastReviewed={isoYesterday}
            reviewedBy={{
                type: "Organization",
                name: "RWA.xyz",
            }}
        />
    );
}
